'use strict';

exports.__esModule = true;
var CORE_EVENT = exports.CORE_EVENT = 'CORE_EVENT';
var UI_EVENT = exports.UI_EVENT = 'UI_EVENT';
var DEVICE_EVENT = exports.DEVICE_EVENT = 'DEVICE_EVENT';
var TRANSPORT_EVENT = exports.TRANSPORT_EVENT = 'TRANSPORT_EVENT';
var RESPONSE_EVENT = exports.RESPONSE_EVENT = 'RESPONSE_EVENT';
var BLOCKCHAIN_EVENT = exports.BLOCKCHAIN_EVENT = 'BLOCKCHAIN_EVENT';